import React, { useState, useEffect } from 'react';
import { RefreshCw, ShieldAlert } from 'lucide-react';
import { supabase } from '../supabaseClient';
import { APP_VERSION } from '../config';

export const UpdateBanner: React.FC = () => {
  const [needsUpdate, setNeedsUpdate] = useState(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const { data, error } = await supabase
          .from('configuracoes')
          .select('valor')
          .eq('chave', 'min_version')
          .maybeSingle();

        if (!error && data && data.valor) {
          const isOutdated = (min: string, current: string) => {
            const minParts = min.split('.').map(Number);
            const currentParts = current.split('.').map(Number);
            
            for (let i = 0; i < Math.max(minParts.length, currentParts.length); i++) {
              const v1 = minParts[i] || 0;
              const v2 = currentParts[i] || 0;
              if (v1 > v2) return true;
              if (v1 < v2) return false;
            }
            return false;
          };

          if (isOutdated(data.valor, APP_VERSION)) {
            setNeedsUpdate(true);
          }
        }
      } catch (err) {
        console.error("Erro ao checar versão do app", err);
      }
    };

    checkVersion();
  }, []);

  const handleUpdate = async () => {
    // 1. Limpa o Service Worker
    if ('serviceWorker' in navigator) {
      try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (let registration of registrations) {
          await registration.unregister();
        }
      } catch (e) {
        console.error("Falha ao remover Service Worker", e);
      }
    }
    // 2. Força o recarregamento total da página
    window.location.reload();
  };

  if (!needsUpdate) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-xl p-6">
      <div className="max-w-sm w-full bg-slate-900 border-2 border-amber-500 p-8 rounded-3xl text-center shadow-2xl shadow-amber-500/20">
        <div className="w-16 h-16 bg-amber-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <ShieldAlert className="text-amber-500" size={32} />
        </div>
        
        <h2 className="text-2xl font-bold text-white mb-2">Atualização Necessária</h2>
        <p className="text-slate-400 text-sm mb-8 leading-relaxed">
          Você está usando uma versão desatualizada (v{APP_VERSION}). Melhorias críticas no funcionamento do Driver Score foram lançadas.
          Por favor, atualize o aplicativo agora para garantir a precisão dos seus dados.
        </p>

        <button
          onClick={handleUpdate}
          className="w-full py-4 bg-amber-500 hover:bg-orange-600 text-slate-900 font-bold rounded-xl flex justify-center items-center gap-2 transition-transform active:scale-95"
        >
          <RefreshCw size={20} />
          ATUALIZAR AGORA
        </button>
        
        <p className="mt-6 text-[10px] text-slate-500 uppercase tracking-widest">
          Tecnologia de Elite • ROMANOSV3 STUDIO
        </p>
      </div>
    </div>
  );
};
